const API_URL = 'https://wa.me';

interface WhatsAppAPI {
  buildChatLink: (number: string, text: string) => string;
}

export const WhatsApp = (): WhatsAppAPI => ({
  buildChatLink: (number, text) => {
    const url = `${API_URL}/${number}?text=${encodeURIComponent(text)}`;
    return url;
  },
});
